import React from 'react';
import DynamicForm from '../../components/common/form';

const OrganizerForm = ({ initialData, onSubmit, onCancel }) => {
  const isEdit = Boolean(initialData && Object.keys(initialData).length);
    const EMPTY_VALUES = {
  name: '',
  email: '',
  password: '',
  company: '',
  contactNumber:'', 
};
  const fields = [
    {
      name: 'name',
      label: 'Name',
      type: 'text',
      placeholder: 'Enter full name',
      required: true,
       autoComplete: 'off',
    },
    {
      name: 'email',
      label: 'Email',
      type: 'email',
      placeholder: 'Enter email address',
      required: true,
       autoComplete: 'off',
    },
    {
      name: 'password',
      label: 'Password',
      type: 'password',
        placeholder: isEdit  ? 'Leave blank to keep unchanged' : 'Enter password',
      required: !isEdit ,
      // placeholder: initialData ? 'Leave blank to keep unchanged' : 'Enter password',
      // required: initialData ? false : true,
       autoComplete: 'new-password',
    },
    // {
    //   name: 'role',
    //   label: 'Role',
    //   type: 'select',
    //   placeholder: 'Select role',
    //   required: true,
    //   options: [
    //     { value: 'lead', label: 'Lead' },
    //     { value: 'assistant', label: 'Assistant' },
    //     { value: 'manager', label: 'Manager' }
    //   ]
    // },
    {
      name: 'company',
      label: 'Company',
      type: 'text',
      placeholder: 'Enter company name',
      required: true,
       autoComplete: 'off',
    },
    {
      name: 'contactNumber',
      label: 'Contact Number',
      type: 'text',
      placeholder: 'Enter contact number',
      required: true,
       autoComplete: 'off',
    }
  ];

  return (
    <DynamicForm
      fields={fields}
      initialValues={isEdit  ? initialData : EMPTY_VALUES}
      onSubmit={onSubmit}
      onCancel={onCancel}
      submitText="Save Organizer"
      cancelText="Cancel"
    />
  );
};

export default OrganizerForm; 